import { FaArrowLeft } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../ui'

interface BackButtonProps {
    to: string
    text?: string
    className?: string
}

/** Small "back" link button. `PageHeader backTo` covers most cases. */
export const BackButton = ({ to, text = 'Back', className = '' }: BackButtonProps) => {
    const navigate = useNavigate()
    return (
        <Button variant="link" icon={<FaArrowLeft />} className={className} onClick={() => navigate(to)}>
            {text}
        </Button>
    )
}
